import React from "react"
import {
  AboutYouInfoQuestionKey,
  JourneyInfoQuestionKey,
  MedicalInfoAnswerKey,
  MedicalInfoQuestionKey
} from "../../utils/RoutingInfoQuestionKey"
import { Question, SubHeader } from "../../utils/RoutingInfoStyles"
import { SkippableAnswer } from "./Answers"
import { getPiiProps } from "services/tracking/pii"

export type RoutingInfoQuestion = {
  questionKey: JourneyInfoQuestionKey | MedicalInfoQuestionKey | AboutYouInfoQuestionKey
  answerKey?: MedicalInfoAnswerKey
  hasAnswer: boolean
  hideQuestion?: boolean
  question: string
  answer: JSX.Element
}

type RoutingInfoQuestionsProps = {
  routingInfoQuestions: RoutingInfoQuestion[]
  skipFields: string[]
  subHeader?: string
}

export function RoutingInfoQuestions({
  routingInfoQuestions,
  skipFields,
  subHeader = null
}: RoutingInfoQuestionsProps): JSX.Element {
  const questionsToShow = routingInfoQuestions.filter(
    (q) => (skipFields?.includes(q.questionKey) || q.hasAnswer) && !q.hideQuestion
  )

  return (
    <>
      {subHeader && <SubHeader>{subHeader}</SubHeader>}
      {questionsToShow.map((q) => (
        <React.Fragment key={q.questionKey}>
          <div id={q.questionKey}>
            <Question>{q.question}</Question>
            <SkippableAnswer questionKey={q.questionKey} skipFields={skipFields}>
              <div className={"answer"} {...getPiiProps()}>
                {q.answer}
              </div>
            </SkippableAnswer>
          </div>
        </React.Fragment>
      ))}
    </>
  )
}
